import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export interface AuthContextValue {
  session: Session | null;
  user: User | null;
  /** True until the initial session lookup resolves. */
  initialising: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  sendPasswordReset: (email: string) => Promise<void>;
  updatePassword: (password: string) => Promise<void>;
}

// Kept in its own module so AuthProvider.tsx exports a component and nothing else,
// which is what react-refresh needs to hot-reload it reliably.
export const AuthContext = createContext<AuthContextValue | null>(null);
